import { render } from "./CatalogView.vue?vue&type=template&id=6cdfd072&scoped=true"
import script from "./CatalogView.vue?vue&type=script&lang=js"
export * from "./CatalogView.vue?vue&type=script&lang=js"

import "./CatalogView.vue?vue&type=style&index=0&id=6cdfd072&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cdfd072"]])

export default __exports__